export type Review = {
    author_name: string
    author_url: string
    language?: string
    original_language?: string
    profile_photo_url: string
    rating: number
    relative_time_description: string
    text: string
    time: number
    translated: boolean
}

export const cachedReviews: Review[] = [
    {
        author_name: 'Ivana Flek',
        author_url: 'https://www.google.com/maps/contrib/113033048043999576129/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUP8bDnEfz5E1z7yL00zspFcIAIPY99iCXyCZLDICvY7zfSJo3E=s128-c0x00000000-cc-rp-mo-ba3',
        rating: 5,
        relative_time_description: 'v zadnjem tednu',
        text: "A very pleasant experience of our little one's first visit, I admit that I was afraid of how he would behave, but would he even open his mouth, and after such a pleasant reception, my Leon didn't even want to go home. Very professional, but at the same time very pleasant and warm treatment. Worth every cent.\nI recommend it to all mothers who don't know where to take their child for their first dental check-up.\nAll praises to Urška and Katja! ❤️",
        time: 1718302578,
        translated: false,
    },
    {
        author_name: 'Teja Kozan',
        author_url: 'https://www.google.com/maps/contrib/112726614307754444208/reviews',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocKJ57n5ExakqyZBK-3P9B4q3Qlxk8Ps_VPOgeu2nrCw-EQ_nA=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'v zadnjem tednu',
        text: '',
        time: 1718085259,
        translated: false,
    },
    {
        author_name: 'Zoran Farkaš',
        author_url: 'https://www.google.com/maps/contrib/107138270982334977828/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjU12541y7pAte0rEz4sc6v5c_6qRBuYdi_RHEou2qqfJERwWDOK=s128-c0x00000000-cc-rp-mo-ba4',
        rating: 5,
        relative_time_description: 'pred 7 meseci',
        text: 'The best, friendliest, most compassionate dentist in Bela Krajina.... 🥰\nShe pulled my teeth without me even feeling anything 😁',
        time: 1698011906,
        translated: false,
    },
    {
        author_name: 'Katja Bahor',
        author_url: 'https://www.google.com/maps/contrib/110261297256656113381/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjVjGb1HEzf98qoR42yuwNhTNczVQUJ5ZnuHkmC2ICq5vPosgY5a=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred 7 meseci',
        text: 'Friendly, professional and communicative dentist who truly works with feeling. Offers a wide range of dental services that no longer require a trip to Ljubljana. Pleasant and relaxing atmosphere. I will definitely be back 😀.',
        time: 1696593279,
        translated: false,
    },
    {
        author_name: 'Boštjan Dolenc',
        author_url: 'https://www.google.com/maps/contrib/108481296949765928669/reviews',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUlvJ0QMNO_hbzjndzB3n-lxGcmWBOinh93E67jmbA7jYvwUH8=s128-c0x00000000-cc-rp-mo-ba5',
        rating: 5,
        relative_time_description: 'pred 9 meseci',
        language: 'sl',
        original_language: 'sl',
        text: '',
        time: 1691417061,
        translated: false,
    },
    {
        author_name: 'Nina Kapušin',
        author_url: 'https://www.google.com/maps/contrib/112671935274444397803/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjWdHYySFrcSn-gHDsdyNgtf6nYhEUXryAsN6A_eIjsgMeYHrcs=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred 11 meseci',
        text: 'Every procedure and device that will come close to their teeth is explained to the child. The child is praised and ultimately rewarded, and proud, which I think is very important for subsequent visits.',
        time: 1686601117,
        translated: false,
    },
    {
        author_name: 'Mira',
        author_url: 'https://www.google.com/maps/contrib/102119478795611219679/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocJp6prSqWsYXCKsqQCG3hxBLAZjznDinCqj1PiX-XZ3wj7kyg=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred enim letom',
        text: 'Relaxing atmosphere, warm, pleasant and professional dentist. She really takes her time and cares about the patient.\nShe changed our experience of going to the dentist 100%.',
        time: 1684509370,
        translated: false,
    },
    {
        author_name: 'Lidija Pezdirc',
        author_url: 'https://www.google.com/maps/contrib/107528924097610364108/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocJHa4cumm6I7T3ClZ4C4zIsVtICb7-U2e6DUmERfQlJfTDfbw=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred enim letom',
        text: 'Very friendly and professionally skilled dentist, who works very gently and knows what fear of the dentist means. Very nice and relaxing atmosphere. We were very satisfied.',
        time: 1684990760,
        translated: false,
    },
    {
        author_name: 'Katarina Vraničar',
        author_url: 'https://www.google.com/maps/contrib/104033738189140259737/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUXR0_fD5lPouqdkz1TLRMGphNIaBkTrPemjoXx_hw0Yhu5p8g=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred enim letom',
        text: 'A truly friendly and professional approach, the dentist works gently, and I especially liked the advice on how to maintain or improve oral hygiene.',
        time: 1684741352,
        translated: false,
    },
    {
        author_name: 'Nika Banovec',
        author_url: 'https://www.google.com/maps/contrib/104124760239200489103/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocLImZvOQhf2ORWaU2stlsQdqjInsJ_9WpRWiK_ArwOVpx0yYg=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred 7 meseci',
        text: 'Great experience, highly commendable. The dentist really has a feel for children. Worth every cent 🙂',
        time: 1697480601,
        translated: false,
    },
    {
        author_name: 'Tanja Matkovič',
        author_url:
            'https://www.google.com/maps/contrib/110110164950738007011?hl=en-US&ved=1t:31294&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUjSWabtOfv1kQ0apT1Au-t31Lo69uraKTWOQ1UTfLaq7BJRu_t=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: 'Very friendly staff, compassionate. Perfect for those who are "afraid" of the dentist. Very pleasant atmosphere.',
        time: 1685631345,
        translated: false,
    },
    {
        author_name: 'Karmen Križan',
        author_url:
            'https://www.google.com/maps/contrib/102834410123142713172?hl=en-US&ved=1t:31293&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocLvXQB8qVhZVSv4wDlP0inQiUt8E-iVUn5nLwVn3Q6zNcQmyQ=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: "Compassionate dentistry is the right choice for adults and children. After the first visit, my daughter happily said that she can't wait for the next visit because dentist Urška is great. Thank you for working with your heart!",
        time: 1694363424,
        translated: false,
    },
    {
        author_name: 'Petra Žlogar Raztresen',
        author_url:
            'https://www.google.com/maps/contrib/103202169970283790039?hl=en-US&ved=1t:31293&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjX02YqcdYydqHVOi_Hc_TE4JfcLbFg0N7cXe1aghaMksz-KxJeH=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: 'As the name suggests; truly compassionate dentistry! We were very satisfied with the treatment.',
        time: 1692721824,
        translated: false,
    },
    {
        author_name: 'Nina Koren',
        author_url:
            'https://www.google.com/maps/contrib/116194450023092046432?hl=en-US&ved=1t:31294&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUAgGVzVoqmzcd8kozSw4PSGODCdFx0bFrRKkdHTEhxlVUE5bwb=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: "A very pleasant experience of our little one's first visit, professional, yet very pleasant and warm treatment. I recommend",
        time: 1691857824,
        translated: false,
    },
    {
        author_name: 'helena lesica',
        author_url:
            'https://www.google.com/maps/contrib/105764737779095953804?hl=en-US&ved=1t:31293&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjU1o4_GSpQp3tIoroiuQCPRI6pClClnCRu2VZqz1Xn9P_GojlTp=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: '',
        time: 1689784224,
        translated: false,
    },
    {
        author_name: 'Dajana Car',
        author_url:
            'https://www.google.com/maps/contrib/102891702876198975200?hl=en-US&ved=1t:31293&ictx=111',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocKkBrivnUhJTjzrJJTB645xBfZSL45dKB_baKLROnlmiPyReQ=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 1 letom',
        text: '',
        time: 1689438624,
        translated: false,
    },
    {
        author_name: 'Maja Štubljar Fendre',
        author_url: '',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocLrwYTtHVNyQ28BUblNmS0w0U7N25KcQOkIPpdMnDrBcvTQ9A=s64-c-rp-mo-br100',
        rating: 5,
        relative_time_description: 'pred 8 meseci',
        text: '',
        time: 1726963200,
        translated: false,
    },
    {
        author_name: 'Aleksander Zbogar',
        author_url: '',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjWCpY8Ex6_RB_w6eS827KWMwf9DRsWKT4HxRnPljwdLpjd4jqmE=s64-c-rp-mo-ba2-br100',
        rating: 5,
        relative_time_description: 'pred 8 meseci',
        text: 'Very responsive and friendly, I even got to the appointment quickly.',
        time: 1724284800,
        translated: false,
    },
    {
        author_name: 'Tanja Derzanic',
        author_url: 'https://www.google.com/maps/contrib/104914988084508857700/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjXvPxIlRjZCmWsS0hfTNdsrJ6uqNmcB902rQx0mjM5x0wM207zu=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'v zadnjem tednu',
        text: 'Urška and Katja are the most compassionate dental professionals I have ever met, but I have had many dental procedures at different dentists. I have never had an approach and manner like theirs at any clinic, which is very important to me, because I have a lot of fear and many problems since my early youth. The fear is probably rooted in previous experiences when I was "spat" and massacred during procedures. Urška and Katja can be an example to local dentists, with their dedication, approach, compassion, knowledge and equipment. Even the child is her patient and always happily goes for a check-up because she says "Urška is the law"!. Bravo girls, keep it up. See you soon :)',
        time: 1747842935,
        translated: false,
    },
    {
        author_name: 'Rok Narobe',
        author_url: 'https://www.google.com/maps/contrib/110959652861350961764/reviews',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocKgTQlDUWruoNXAOvxbDiXgAOoaNn0PyLvQJtLdhTRPuldDqg=s128-c0x00000000-cc-rp-mo',
        rating: 5,
        relative_time_description: 'pred 3 meseci',
        text: '',
        time: 1738304106,
        translated: false,
    },
    {
        author_name: 'Katja Mercina',
        author_url: 'https://www.google.com/maps/contrib/103519512429682180252/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjX9x5HbMdugRRSbV7NPXRriedy49WHR4ORMrPy2jEUD61tW0TLP=s128-c0x00000000-cc-rp-mo-ba2',
        rating: 5,
        relative_time_description: 'pred 4 meseci',
        text: 'The best dentist for children, especially if they are a little timid. I am thrilled, thank you 100x for your approach <3',
        time: 1736148925,
        translated: false,
    },
    {
        author_name: 'jasmina lesjak',
        author_url: 'https://www.google.com/maps/contrib/105344660123268688310/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a/ACg8ocLkrUf3hphV_tHhaFy6HtgcQv5Ggv2tuDUQ3T7GbmH0nZIRHkY=s128-c0x00000000-cc-rp-mo-ba3',
        rating: 5,
        relative_time_description: 'pred 5 meseci',
        text: 'The dentist is gentle, with feeling, professional, precise. The assistant is extremely friendly, our little one was delighted! We were very satisfied, we will be happy to come back. A pleasant experience, I recommend! ☺️',
        time: 1734087045,
        translated: false,
    },
    {
        author_name: 'Boris K.',
        author_url: 'https://www.google.com/maps/contrib/113886937631847299461/reviews',
        language: 'sl',
        original_language: 'sl',
        profile_photo_url:
            'https://lh3.googleusercontent.com/a-/ALV-UjUmiGlYzHAPRHSmtTKNQ6Pz_Fz1esgIC0gxXfUVBAR6HjT86HNj=s128-c0x00000000-cc-rp-mo-ba3',
        rating: 5,
        relative_time_description: 'pred 7 meseci',
        text: 'I am very satisfied and happy that I sought help and decided on this dental office, because with their help I managed to arrange my previously spaced and missing teeth into a perfect smile in half a year.\nThe result is 100%!\nLet the attached photo tell you everything.\nCompassionate is not just the name of the office, it is really their motto and way of working.\nI recommend the office to everyone, I talked to mothers in the waiting room a few times who brought their children there, and they were all enthusiastic about the approach of the dentist, Dr. Urška Šavli.\nLest you think that I was waiting in the office for my turn: not at all, the appointment times are nicely arranged, my meetings and conversations with young patients and their mothers took place when I brought my wife to the office for the procedure, who is also very satisfied with the process of straightening her teeth using Invisalign prosthetics.',
        time: 1728893728,
        translated: false,
    },
]
